import { Dispatch } from '../../architecture/frontend/index'

const TestType = (props) => {
  const type = props._type
  return (
    <div className='w-50 pv1 ph3 flex justify-center'>
      <div className='w-70 black br3 pa1  tc f6 ba b--gray' style={{background: '#c8c1ba'}}>
        {type}
      </div>
    </div>
  )
}

const Row = (props) => {
  const test = props._test
  const slug = props._test?.toLowerCase()
  const even = props._even ? '#ebf3ee' : '#f1f1ef'
  const top = props._top
  const bottom = props._bottom
  return (
    <div className={'w-100 flex ' + (top ? ' pt2 ' : '') + (bottom ? ' pb2 ' : '')}  style={{background: even}}>
      <div className='w-40 flex items-center'>
          <TestType _type={test}/>
          <div className='w-50 flex justify-center'>
            {/* <Textbox 
              className='w3 pa2 br2 bg-white tc f7 ba b--moon-gray '
              id={slug+'.shipmentPercent'}
              placeholder='%'
              style={{ outline: 'none', borderStyle: 'solid' }}
              type='text'
              defaultValue={props.shipment?.[slug+'ShipmentPercent']}
            /> */}
            <input 
              className='w3 pa2 br2 bg-white tc f7 ba b--moon-gray ' 
              style={{ outline: 'none', borderStyle: 'solid' }} 
              type="text" 
              name={slug}
              placeholder='%'
              defaultValue={props.shipment?.['shipment' + test + 'Percent']}
              onChange={e => Dispatch.nextAction('shipment.set', {type: 'shipment' + test + 'Percent', value: e.target.value})}
            />
          </div>
      </div>

        <div className='w-40 flex items-center justify-around bl b--moon-gray'>
          <div className='w-50 flex justify-center'>
            {/* <Textbox 
              className='w3 pa2 br2 bg-white tc f7 ba b--moon-gray '
              id={slug+'.claimPercent'}
              placeholder='%'
              style={{ outline: 'none', borderStyle: 'solid' }}
              type='text'
              defaultValue={props.shipment?.[slug+'ClaimPercent']}
            /> */}
            <input 
              className='w3 pa2 br2 bg-white tc f7 ba b--moon-gray ' 
              style={{ outline: 'none', borderStyle: 'solid' }} 
              type="text" 
              name={slug}
              placeholder='%'
              defaultValue={props.shipment?.['claim' + test + (test === 'Moisture' ? '' : '12') + 'Percent']}
              onChange={e => Dispatch.nextAction('shipment.set', {type: 'claim' + test +  (test === 'Moisture' ? '' : '12') + 'Percent', value: e.target.value})}
            />
            {/* <div className='w3 pa2 br2 bg-white tc f7 ba b--moon-gray'>%</div> */}
          </div>
          <div className='w-50 flex justify-center'>
            {/* <Textbox 
              className='w3 pa2 br2 bg-white tc f7 ba b--moon-gray '
              id={slug+'.claimDollar'}
              placeholder='$'
              style={{ outline: 'none', borderStyle: 'solid' }}
              type='text'
              defaultValue={props.shipment?.[slug+'ClaimDollar']}
            /> */}
            <input 
              className='w3 pa2 br2 bg-white tc f7 ba b--moon-gray ' 
              style={{ outline: 'none', borderStyle: 'solid' }} 
              type="text" 
              name={slug}
              placeholder='$'
              defaultValue={props.shipment?.['claim' + test + 'Dollars']}
              onChange={e => Dispatch.nextAction('shipment.set', {type: 'claim' + test + 'Dollars', value: e.target.value})}
            />
          </div>
        </div>
        <div className='w-20 flex items-center justify-around bl b--moon-gray'>
          <div className='w-50 flex justify-center'>
          {/* <Textbox 
              className='w3 pa2 br2 bg-white tc f7 ba b--moon-gray '
              id={slug+'.refereePercent'}
              placeholder='%'
              style={{ outline: 'none', borderStyle: 'solid' }}
              type='text'
              defaultValue={props.shipment?.[slug+'RefereePercent']}
            /> */}
            <input 
              className='w3 pa2 br2 bg-white tc f7 ba b--moon-gray ' 
              style={{ outline: 'none', borderStyle: 'solid' }} 
              type="text" 
              name={slug}
              placeholder='%'
              defaultValue={props.shipment?.['referee' + test + ((test === 'Protein' || test === 'Fiber') ? '12' : '') + 'Percent']}
              onChange={e => Dispatch.nextAction('shipment.set', {type: 'referee' + test + ((test === 'Protein' || test === 'Fiber') ? '12' : '') + 'Percent', value: e.target.value})}
            />
          </div>
          {/* <div className='w-50 flex justify-center'>
            <div className='w-100 pa2 mr3 br2 bg-white tl f7 ba b--moon-gray'>Remarks</div>
          </div> */}
          {/* <div className='w-20 flex justify-center'>
            <FontAwesomeIcon className='f4 ' icon={faFileAlt} style={{color: '#7bb093'}}/>
          </div> */}
        </div>

    </div>
  )
}

export default Row